<template>
    <div :class="!isMobile?'Entreprise':'mEntreprise mobileCommon'">
        <p class="SubTitle">{{ langPage['v4-entreprise']['TXT_monentreprise'] }}</p>

        <el-form label-position="top" :model="formdata">
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['v4-inscription-grossistes']['TXT_raisonsocial'] }}*</span>
                </slot>
                <el-input class="input" v-model="formdata.nomSociete"></el-input>
            </el-form-item>
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['v4-entreprise']['TXT_siret'] }}*</span>
                </slot>
                <el-input v-model="formdata.tva_intra" :disabled="!is_visitor"></el-input>
                <el-button v-if="!is_visitor" @click="$router.push('/conditions/contact')">contact us to modify</el-button>
            </el-form-item>
            <el-form-item v-if="is_visitor">
                <input
                    id="file_carte"
                    name="file_carte"
                    type="file"
                    accept="image/*"
                    value
                    ref="carte_upload"
                    hidden
                    @change="carteFile($event,100)"
                />
                <slot name="label">
                    <label for="file_carte" class="formLabel file-btn">{{ langPage['v4-inscription-grossistes']['TXT_choisirunfichir'] }}</label>
                </slot>
                <div class="tip-warp">
                    <template v-if="kbis_img_buyer.name">
                        <div class="tip">
                            {{kbis_img_buyer.name}}
                            <i class="el-icon-close carte-size" @click="delCarteImg(index,2)"></i>
                        </div>
                    </template>
                    <template v-else>
                        <div class="tip">{{langPage['v4-signpage']['TXT_aucunfichierchoisi']}}</div>
                    </template>
                </div>
            </el-form-item>
<!--            <el-form-item>-->
<!--                <slot name="label">-->
<!--                    <span class="formLabel">{{ langPage['v4-entreprise']['TXT_choisissezunpays'] }}</span>-->
<!--                </slot>-->
<!--                <el-select v-model="formdata.Choisissez" @change="onChangeBuyerCountry" placeholder="">-->
<!--                    <el-option-->
<!--                            v-for="item in nations"-->
<!--                            :key="item.id_pays"-->
<!--                            :label="item.texte_uk"-->
<!--                            :value="item.id_pays"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="eori*"
                          v-if="is_show_eori"
                          prop="eori">
                <el-input class="input" v-model="formdata.eori"></el-input>
            </el-form-item>
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['bov-compte-informationsgenerales']['TXT_siteweb'] }}</span>
                </slot>
                <el-input class="input" v-model="formdata.site_web"></el-input>
            </el-form-item>
            <el-form-item>
                <slot name="label">
                    <span class="formLabel">{{ langPage['compte-informations']['TXT_languedefaut'] }}*</span>
                </slot>
                <el-select v-model="formdata.LangueDefaut" placeholder="">
                    <el-option
                            v-for="item in langs"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="chex-box">
            <p class="formLabel">{{ langPage['v4-entreprise']['TXT_domainedactivite'] }}</p>
            <div>
                <el-checkbox-group class="itemgroup" v-model="checkList">
                    <el-checkbox class="item" v-for="(item,i)  in checkLdata" :key="i"
                                 :label="item.id_activite">{{item.libelle}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <div class="opt">
            <div></div>
            <button class="enregistrer" @click="sub" v-loading="is_loading">{{ langPage['bov-catalogue-promotions']['TXT_enregistrer'] }}</button>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Entreprise",

        data() {
            return {
                isMobile: this.$store.state.isMobile,
                is_loading:false,
                submitState: true,
                kbis_img_buyer:{},
                is_visitor: this.$store.state.userInfo.statut==3,
                formdata: {
                    nomSociete: "",
                    nomContact: "",
                    SIRET: "",
                    tva_intra: "",
                    Choisissez: "",
                    site_web: "",
                    LangueDefaut: "",
                    password: "",
                    prenomContact: "",
                    facebook: "",
                    instragram: "",
                    eori: this.$store.state.userInfo.eori,
                    activites:'',
                },
                fileList: [],
                langPage: this.$store.state.langPage,
                langs: [
                    {
                        value: "1",
                        label: "fr"
                    },
                    {
                        value: "2",
                        label: "en"
                    },
                    {
                        value: "3",
                        label: "es"
                    },
                    {
                        value: "4",
                        label: "it"
                    },
                ],
                nations: [],
                faliname: "",
                checkList: [],
                checkLdata: [
                    {
                        libelle: "Vêtements femme",
                        id_activite: "1"
                    },
                ],
                is_show_eori: false,
            };
        },
        created() {
            this.getNations();
            this.getInfo()
            this.fetchActivites(this.lang)
        },
        computed: {
            loadDisabled() {
                return this.fileList.length > 0
            },
            lang() {
                return localStorage.getItem('lang') || 'fr'
            }
        },
        methods: {
            delFile(data) {
                this.fileList.splice(data, 1)
            },
            loadSuccess(file) {
                console.log(file)
            },
            checkType(type) {
                let reg = /^(image\/(jpg|jpeg|gif|png)|application\/pdf)/
                return reg.test(type)
            },
            sub() {
                // console.log('checkList2',this.checkList)
                this.is_loading = true;
                if (this.checkList.length>0){
                    this.formdata.activites = this.checkList.join(',');
                }
                let reqData = {...this.formdata};
                let param = new FormData();
                for (var keys of Object.keys(reqData)) {
                    if (reqData[keys] && reqData[keys].length > 0) {
                        param.append(keys, reqData[keys]);
                    }
                }
                param.append('kbis_img_buyer', this.kbis_img_buyer);
                this.$loading({
                    lock: true,
                    spinner: "el-icon-loading"
                });
                this.$api.info.update(param).then(res => {
                    if (res.code == 0) {
                        this.$message.success(res.message)
                        this.getInfo()
                    }
                }).finally(() => {
                    this.submitState = true;
                    this.is_loading = false;
                    this.$loading().close();
                })
            },
            fetchActivites(para) {
                this.$api.info.fetchActivites({id_langue: para}).then((res) => {
                    this.checkLdata = res.result;
                })
            },
            getInfo() {
                // let th = this;
                this.$api.info.getInfo().then(res => {
                    for (var key1 in this.formdata) {
                        for (var key2 in res.acheteur) {
                            if (key1 == key2) {
                                this.formdata[key1] = res.acheteur[key1]
                            }
                        }
                    }
                    let activites = res.acheteur.activites;
                    this.checkList=[];
                    for (let activite of activites){
                        this.checkList.push(activite.id_activite);
                    }
                    console.log('checkList',this.checkList)
                }).catch(err => {
                    console.log(err)
                })
            },
            getNations() {
                this.$api.info.getNations().then(res => {
                    this.nations = res;
                    this.formdata.Choisissez = this.nations[0].id_pays
                }).catch(err => {
                    console.log(err)
                })
            },
            onChangeBuyerCountry(id_pays) {
                let country = this.nations.find(item => item.id_pays === id_pays);
                //是英国要要求设置eori
                this.is_show_eori = country.id_pays==24;
            },
            carteFile(e, type) {
                let file = e.target.files[0];
                if (file.size > 1024 * 1024 * 5) {
                    this.$message.warning(this.$t("文件大小不能超过5M!"));
                    return
                }
                switch (type) {
                    case 1:
                        this.kbis_img = file;
                        break;
                    case 2:
                        this.carte_img = file;
                        break;
                    case 100://100以上的图片类型算买家的，100以内的算卖家的
                        this.kbis_img_buyer = file;
                        break;
                }
            },
            delCarteImg(val, key) {
                let objType = "";
                switch (key) {
                    case 1:
                        objType = "kbis_img";
                        break;
                    case 2:
                        objType = "carte_img";
                        break;
                    case 100:
                        objType = "kbis_img_buyer";
                        break;
                }
                this[objType] = {}
            }
        }
    };
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Entreprise.less">
</style>
<style lang="less">
    .Entreprise {
        .el-select {
            width: 100%;
        }
    }

    .mEntreprise {
        .el-select {
            width: 100%;
        }
    }
</style>
